import { siteInfo } from "@/mocks/site";
import { INSTAGRAM_LINK, TEL_LINK } from "@/utils/whatsapp";

const quickLinks = [
  { label: "Kampanyalar", href: "#kampanyalar" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Galeri", href: "#galeri" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Footer() {
  return (
    <footer className="emerald-canvas relative">
      <div className="gold-rule" aria-hidden="true" />

      <div className="mx-auto w-full max-w-7xl px-5 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4">
              <span className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full ring-1 ring-accent-500/60">
                <img
                  src={siteInfo.logo}
                  alt="Fatma Angay Güzellik Salonu logosu"
                  title="Fatma Angay Güzellik Salonu"
                  className="h-full w-full object-contain"
                />
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-xl font-semibold tracking-wide text-background-50">
                  FATMA ANGAY
                </span>
                <span className="font-label text-[0.62rem] font-medium uppercase tracking-[0.34em] text-accent-500">
                  Güzellik Salonu
                </span>
              </span>
            </div>

            <p className="mt-5 max-w-sm font-body text-sm leading-relaxed text-background-300">
              {siteInfo.addressLine1}
              <br />
              {siteInfo.addressLine2}
              <br />
              {siteInfo.addressLine3}
            </p>

            <p className="mt-4 font-heading text-base italic text-accent-400">{siteInfo.tagline}</p>
          </div>

          <div>
            <h4 className="font-label text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-accent-500">
              İletişim
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              <li>
                <a
                  href={TEL_LINK}
                  className="flex items-center gap-3 font-body text-sm text-background-200 transition-colors hover:text-accent-300"
                >
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className="ri-phone-line text-base text-accent-500" aria-hidden="true" />
                  </span>
                  {siteInfo.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={INSTAGRAM_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 font-body text-sm text-background-200 transition-colors hover:text-accent-300"
                >
                  <span className="flex h-5 w-5 items-center justify-center">
                    <i className="ri-instagram-line text-base text-accent-500" aria-hidden="true" />
                  </span>
                  {siteInfo.instagramHandle}
                </a>
              </li>
              <li className="flex items-center gap-3 font-body text-sm text-background-200">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-map-pin-2-line text-base text-accent-500" aria-hidden="true" />
                </span>
                Demirtaş / Osmangazi / Bursa
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-accent-500">
              Hızlı Bağlantılar
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 font-body text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-s-line text-base text-accent-500" aria-hidden="true" />
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-accent-500/15">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-5 py-6 md:flex-row md:items-center md:justify-between md:px-6">
          <p className="font-body text-xs text-background-400">
            © {new Date().getFullYear()} Fatma Angay Güzellik Salonu. Tüm hakları saklıdır.
          </p>
          <p className="font-body text-xs text-background-400">
            Osmangazi / Bursa — Randevulu hizmet
          </p>
        </div>
      </div>
    </footer>
  );
}